// extracted by mini-css-extract-plugin
module.exports = {"mobilePresenterFeedsHolder":"MobilePresenterFeeds_mobilePresenterFeedsHolder__22rQV","fakePresenterItem":"MobilePresenterFeeds_fakePresenterItem__1A7l8"};